module.exports = __webpack_public_path__ + "img/star-unfilled.7c601d61.svg";